import { List } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(List);
Icon.displayName = "List";

export { Icon as List };
//# sourceMappingURL=List.js.map
